/* global swal angular*/
import './style.less';

export default function($scope, $log, $state, $stateParams, Swal, ApiClass, ProfileClass) {
  'ngInject';

  $scope.expand = false;
  $scope.resultsQueried = false;

  function adminSendApproval() {
    Swal.confirm('Approve Course?', 'This will make the course active and send your feedback to the author')
      .then(() => {
        const updatedCourse = {
          active: true,
          adminApproved: true,
          adminReview: false,
          approval: true,
          course_id: $stateParams.courseId,
          reviewAdmins: []
        };
        return ApiClass.coursesIdPatch({ id: $stateParams.courseId, manage: true }, { course: updatedCourse });
      })
      .then(() => {
        $state.go('app.admin.courses.review', $stateParams);
        Swal.toast('Course is Active');
      })
      .catch(error => {
        $scope.laddaBtnSubmit = false;
        if (error.dismiss) return;
        Swal.toast('Cancelled', 'error');
      });
  }

  function adminSendRejection() {
    return Swal.confirm(
      'Request Revisions?',
      'The course will remain inactive and the author will receive your feedback'
    )
      .then(() => {
        const updatedCourse = {
          active: false,
          adminApproved: false,
          adminReview: false,
          approval: false,
          course_id: $stateParams.courseId,
          submitted: false,
          reviewAdmins: []
        };
        return ApiClass.coursesIdPatch({ id: $stateParams.courseId, manage: true }, { course: updatedCourse });
      })
      .then(() => {
        $state.go('app.admin.courses.review', $stateParams);
        Swal.toast('Feedback Sent');
      })
      .catch(error => {
        $scope.laddaBtnSubmit = false;
        if (error.dismiss) return;
        Swal.toast('Cancelled', 'error');
      });
  }

  $scope.save = function(save) {
    if (save) $scope.laddaBtnSave = true;
    const course_id = $scope.formData.course_id;
    const adminReview = {
      course_id,
      'course-info': $scope.formData['course-info'],
      'event-materials': $scope.formData['event-materials'],
      'final-questions': $scope.formData['final-questions'],
      'modules-info': $scope.formData['modules-info'],
      comments: $scope.formData.comments
    };
    return ApiClass.coursesIdTypePut({ id: course_id, type: 'adminReviews' }, { adminReview })
      .then(() => {
        $scope.commentForm.$setPristine();
        $scope.commentForm.$setUntouched();
        if (save) {
          $scope.laddaBtnSave = false;
          return Swal.toast('Your comments have been saved.');
        }
        return;
      })
      .catch($log.error);
  };

  $scope.submit = function(form) {
    $scope.laddaBtnSubmit = true;
    $scope
      .save()
      .then(() => {
        if (form.activateCourse) return adminSendApproval();
        return adminSendRejection();
      })
      .catch(error => {
        $scope.laddaBtnSubmit = false;
        Swal.toast('Cancelled', 'error');
        $log.error(error);
        throw error;
      });
  };

  ApiClass.coursesIdGet({ id: $stateParams.courseId }, {}, { queryParams: { manage: true } })
    .then(({ data: { course } }) => {
      const { profile } = ProfileClass.profileComplete;
      $scope.formData = {
        course_id: course.course_id,
        reviewerName: `${profile.first} ${profile.last}`,
        activateCourse: false
      };

      $scope.deliveryMethod = course.delivery_method;
      $scope.formData = angular.merge($scope.formData, course.review);
      $scope.resultsQueried = true;
    })
    .catch(error => {
      $log.error(error);
      throw error;
    });
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin.courses.course.review/index.js